import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useGetPointsOfSalesQuery } from '~entities/pos';

import { Multiselect } from '@breeze/rhf-adapters';

import { getPointsOfSaleOptions } from '../../lib/get-points-of-sale-options';
import type { FiltersValue } from '../filters/filters';

export function PosFilter<T>({
  onFilterChanged,
}: {
  onFilterChanged: () => void;
}) {
  const { control, watch } = useFormContext<FiltersValue<T>>();
  const { data: posData, isLoading: isPosDataLoading } =
    useGetPointsOfSalesQuery();
  const selectedMerchantsIds = watch('merchantIds');

  const filteredByMerchantPos = useMemo(() => {
    if (!selectedMerchantsIds?.length) {
      return posData;
    }

    const merchantsSet = new Set(selectedMerchantsIds);

    return posData?.filter((pos) => merchantsSet.has(pos.merchantId));
  }, [selectedMerchantsIds, posData]);

  const posOptions = useMemo(
    () =>
      filteredByMerchantPos
        ? getPointsOfSaleOptions(filteredByMerchantPos)
        : [],
    [filteredByMerchantPos]
  );

  return (
    <Controller
      control={control}
      name="posIds"
      render={(fieldProps) => (
        <Multiselect
          {...fieldProps}
          label="Stores"
          size="m"
          options={posOptions}
          loading={isPosDataLoading}
          onClose={onFilterChanged}
        />
      )}
    />
  );
}
